import {cn} from 'app/utils/styles.utils';

export default function Title({
  title,
  className,
}: {
  title: string;
  className?: string;
}) {
  const lines = title.split('<br />');
  return (
    <h1
      className={cn([
        'bg-gradient-to-r from-gray-200 via-white to-gray-200 bg-clip-text pb-2 text-center text-4xl font-medium leading-[66px] text-transparent desktop:text-6xl tablet:text-4xl mobile:text-3xl',
        className,
      ])}>
      {lines.map((line, index) => (
        <span key={index}>
          {line}
          {index < lines.length - 1 && <br />}
        </span>
      ))}
    </h1>
  );
}
